module.exports = __webpack_public_path__ + "img/prograde.9f3b14f6.svg";